interface ImagePreviewProps {
  isGenerating: boolean;
  generationStep: string;
  transformedURL: string | null;
  templateURL: string;
}

export default function ImagePreview({
  isGenerating,
  generationStep,
  transformedURL,
  templateURL,
}: ImagePreviewProps) {
  if (isGenerating) {
    return (
      <div className="image-preview-container">
        <div className="image-placeholder">
          <Spinner />
          <span>{generationStep || "Wird verarbeitet..."}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="image-preview-container">
      <img
        src={transformedURL ?? templateURL}
        alt={transformedURL ? "Generiertes Bild" : "Template-Vorschau"}
      />
    </div>
  );
}

function Spinner() {
  return (
    <div
      style={{
        width: 20,
        height: 20,
        border: "3px solid #ddd",
        borderTopColor: "#4a90e2",
        borderRadius: "50%",
        animation: "spin 0.8s linear infinite",
      }}
    />
  );
}